export type TColorKey = keyof typeof OwnableTheme.colors;
export type TColor = typeof OwnableTheme.colors[TColorKey];

export const OwnableTheme = {
  colors: {
    transparent: 'transparent',
    translucentIndigo: 'rgba(60, 42, 142, 0.65)',
    ultraTranslucentIndigo: 'rgba(60, 42, 142, 0.3)',
    // todo: value was being used in the app, but didnt exist in the theme.
    // copied value from darkPalePersianIndigo
    offWhite: '#FAF7F2',
    midPersianIndigo: '#E6E4FF',
    persianIndigo: '#3C2A8E',
    mercury: '#F2F2F2',
    deepAmaranth: '#FF2F5A',
    amaranth: '#ff2f5a',
    amaranthRollover: '#e62f5a',
    white: '#FFFFFF',
    black: '#000000',
    green: '#BFF0BD',
    productThumbnailScreenAlpha: 'rgba(38, 33, 33, 0.05)',
    paleBrown: '#fdf7ef',
    paleBrownRollover: '#f0e5da',
    midBrown: '#EAD9C0',
    midBrownRollover: '#ddcabb',
    paleGreen: '#E8F9E4',
    paleGreenRollover: '#d8e9d2',
    paleRed: '#F8DCDC',
    paleRedRollover: '#e6cdce',
    paleBlue: '#E9F1FF',
    paleBlueRollover: '#d0dbf4',
    palePersianIndigo: '#F0F0FA',
    darkPalePersianIndigo: '#E6E4FF',
    veryPaleBrown: '#FFFBF6',
    midPersianIndigoRollover: '#c3bee9',
    errorRed: 'red',
    yellow: '#ffd76e',
    menuShadow: 'rgba(0, 22, 119, 0.4)',
    // https://chir.ag/projects/name-that-colors
    minsk: '#382F88',
    transparentViolet: 'rgba(67,51,165,0.7)',
    modalShadow: 'rgba(0, 0, 0, 0.25)',
    modalShadowDark: 'rgba(0, 0, 0, 0.7)',
    lightGray: '#E8E8E8',
    paleGray: '#CDCDCD',
    gray: '#B8B6B6',
    grayInput: '#E4E4E4',
    darkGray: '#8C8C8C',
  },
  fonts: {
    gilroy: {
      light: 'light',
      regular: 'regular',
      bold: 'bold',
      semibold: 'semibold',
      black: 'black',
    },
  },
  fontSizes: {
    xxxxl: '160px',
    xxxl: '60px',
    xxl: '48px',
    xl: '32px',
    l: '24px',
    ml: '22px',
    m: '20px',
    s: '18px',
    xs: '16px',
    xxs: '14px',
    xxxs: '12px',
    x4s: '10px',
  },
  fontSizesNumerical: {
    xxxxl: 160,
    xxxl: 60,
    xxl: 48,
    xl: 32,
    l: 24,
    ml: 22,
    m: 20,
    s: 18,
    xs: 16,
    xxs: 14,
    xxxs: 12,
    x4s: 10,
  },
  layers: {
    /** 1000 */
    floatingNav: '1000',
    /** 900 */
    pageHeader: '900',
    /** 800 */
    productDetailDrawer: '800',
    /** 700 */
    quickNavigationDrawer: '700',
  },
};

export default OwnableTheme;
